import HTTPService from '@/services/Http';

async function loadProject({ commit }, projectCode) {
  try {
    const { data } = await HTTPService.getProject(projectCode);
    commit('SET_PROJECT', data);
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export default {
  loadProject,
};
